import { AxiosError } from 'axios';
import RepositoryFactory from '@/repository/RepositoryFactory';

export const getAttendanceContactDeadline = async (facilityId: string) => {
  try {
    const repository = RepositoryFactory.manager.attendanceContactDeadline;
    const response = await repository.detail(facilityId);
    return response.data;
  } catch (e: unknown) {
    const err = e as AxiosError;
    if (err.response) {
      throw err.response;
    }
    throw new Error('通信エラーが発生しました');
  }
};
